import { render, staticRenderFns } from "./writing.vue?vue&type=template&id=638c5bcf&scoped=true"
import script from "./writing.vue?vue&type=script&lang=js"
export * from "./writing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638c5bcf",
  null
  
)

export default component.exports